'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../external/@babel/runtime/helpers/esm/extends.js');

var defineProperty = require('../../external/@babel/runtime/helpers/esm/defineProperty.js');

var objectWithoutProperties = require('../../external/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var React = require('react');

var PropTypes = require('prop-types');

var index = require('../../external/classnames/index.js');

var props = require('../props.js');

var index$1 = require('../../utilities/GatsbyLink/index.js');

var arrow_right_inline = require('../../assets/svg/arrow_right.inline.svg.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["action", "active", "arrow", "block", "children", "circle", "className", "color", "disabled", "download", "gradient", "innerRef", "link", "outline", "role", "size", "social", "tag", "target", "type"];

var Button = function Button(props) {
  var _classNames;

  var action = props.action,
      active = props.active,
      arrow = props.arrow,
      block = props.block,
      children = props.children,
      circle = props.circle,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      download = props.download,
      gradient = props.gradient,
      innerRef = props.innerRef;
  props.link;
  var outline = props.outline,
      role = props.role,
      size = props.size,
      social = props.social,
      Tag = props.tag,
      target = props.target,
      type = props.type,
      attributes = objectWithoutProperties['default'](props, _excluded);
  var classes = index['default'](color && "btn-".concat(color), color && outline && "btn-outline-".concat(color, " lanl-btn-outline"), 'btn lanl-btn', gradient && "".concat(gradient, "-gradient"), (_classNames = {
    active: active,
    'btn-circle': circle,
    'btn-block': block,
    'btn-action': action
  }, defineProperty['default'](_classNames, "btn-".concat(social), social), defineProperty['default'](_classNames, "btn-".concat(size), size), defineProperty['default'](_classNames, "disabled", disabled), _classNames), className);

  if (attributes && attributes.href && Tag === 'button') {
    Tag = index$1['default'];
  }

  var renderArrow = function renderArrow() {
    return arrow && /*#__PURE__*/React__default['default'].createElement(arrow_right_inline['default'], {
      className: "btn-arrow"
    });
  };

  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends['default']({
    "data-testid": "lanl-button",
    type: Tag === 'button' && !type ? 'button' : type,
    target: target,
    role: Tag === 'a' && !role ? 'button' : role,
    className: classes,
    ref: innerRef
  }, attributes, {
    download: download,
    disabled: disabled
  }), children, renderArrow());
};

Button.defaultProps = {
  arrow: true,
  color: 'secondary',
  tag: 'button'
};
Button.propTypes = {
  children: PropTypes__default['default'].node.isRequired,

  /**
   * One of:  black | secondary | white
   */
  color: PropTypes__default['default'].oneOf(props.propColor).isRequired,
  tag: PropTypes__default['default'].string.isRequired,
  action: PropTypes__default['default'].bool,
  active: PropTypes__default['default'].bool,
  arrow: PropTypes__default['default'].bool,
  block: PropTypes__default['default'].bool,
  circle: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  download: PropTypes__default['default'].string,
  gradient: PropTypes__default['default'].string,
  innerRef: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string]),
  link: PropTypes__default['default'].bool,
  onClick: PropTypes__default['default'].func,
  outline: PropTypes__default['default'].bool,
  role: PropTypes__default['default'].string,
  rounded: PropTypes__default['default'].bool,
  size: PropTypes__default['default'].oneOf(['sm', 'lg']),
  social: PropTypes__default['default'].string,

  /**
   * One of: _self | _blank | _parent| _top
   */
  target: PropTypes__default['default'].oneOf(props.propTarget),
  type: PropTypes__default['default'].oneOf(['reset', 'submit', 'button'])
};
exports.Button = Button;
exports['default'] = Button;